module.exports = __webpack_public_path__ + "static/media/game-press-symbol-sports.78beb492.png";